import Environment from "../service/interfaces/Environment";

const _environment: Environment = {
    isProduction: true,
    targetServer: 'https://chasethefox.com/'
};

export default _environment;